import { BASE_URL } from "../../App";
import CustomButton from "../Reusable/CustomButton";
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2';
import { Card } from 'antd';
import NoDataFound from '../image/NO_Data_Found.png';
import { Button, Backdrop, CircularProgress, FormControlLabel, TextField, Radio, RadioGroup, Dialog, DialogTitle, DialogContent, DialogActions, Stack } from '@mui/material';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import ProductSelection_INCLUDE from './ProductSelection_INCLUDE.js';
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded';
import { SelectNormal, SelectSearch, MultipleSelect } from '../Reusable/SelectBox';

export default function Home() {

    const focusRef = useRef(null);
    const navigate = useNavigate();
    const [value, setValue] = React.useState("Product");
    const [Oredrvalue, setOredrvalue] = React.useState(null);
    const [OrderType, setOrderType] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [DealerDetail, setDealerDetails] = useState([]);
    const [dealer, setDealer] = useState([]);
    const [SerialNo, setSerialNo] = useState(null);
    const [FAQ, setFAQ] = useState(false);

    // const location = useLocation();
    // useEffect(() => {
    //     const searchParams = new URLSearchParams(location.search);
    //     const id = searchParams.get('id');
    //     if (id) {
    //         alert(id);
    //     }
    // }, []);

    const login_id = localStorage.getItem("LOGIN_ID");

    const buttonStyle = {
        backgroundImage: 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)',
    };

    useEffect(() => {
        DealerDetails();
        GetOrderType();
    }, []);

    const DealerDetails = () => {
        // if (dealerCode.trim() === '') {
        //     alert('Please enter a dealer code.');
        //     return;
        // }

        setOpen(true);
        const data = { type: 'DealerSearch', User_Id: login_id }
        axios.post(BASE_URL + '/siso', data)
            .then(response => {
                if (response.status === 200) {
                    if (response.data.message.length >= 1) {
                        setDealerDetails(response.data.message);
                    } else {
                        Swal.fire({
                            icon: "info",
                            text: 'Invalid Dealer!'
                        });
                        //navigate('/Home');
                    }
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                    //navigate('/Home/Spares/');
                } else if (error.request) {
                    //navigate('/Home/Spares/');
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            }).finally(() => {
                setOpen(false);
            });
    };

    const GetOrderType = () => {
        setOpen(true);
        const data = { type: 'OrderTye' }
        axios.post(BASE_URL + '/siso', data)
            .then(response => {
                if (response.status === 200) {
                    if (response.data.message.length >= 1) {
                        setOrderType(response.data.message);
                    } else {
                        Swal.fire({
                            icon: "info",
                            text: 'Invalid Dealer!'
                        });
                        //navigate('/Home');
                    }
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: error.response.data.message
                    });
                    // navigate('/Home/siso/');
                }
            }).finally(() => {
                setOpen(false);
            });
    }

    const SerialSearch = () => {

        const dealerInfo = DealerDetail.length === 1 ? DealerDetail[0] : dealer[0];

        if (!dealerInfo) {
            Swal.fire({
                icon: "info",
                text: 'Select Dealer !'
            });
        } else if (!Oredrvalue) {
            Swal.fire({
                icon: "info",
                text: 'Select Order Type !'
            });
        } else {
            setOpen(true);

            const data = { type: 'SerialSearch', Serial_No: SerialNo }
            axios.post(BASE_URL + '/siso', data)
                .then(response => {
                    if (response.data.message.length >= 1) {

                        navigate('/ProductDetails_INLUDE', {
                            state: {
                                Dealer_Code: dealerInfo.DEALER_CODE,
                                Dealer_Name: dealerInfo.DEALERNAME,
                                Itemcode: response.data.message[0].MAT_CODE,
                                ITEMDESCRIPTION: response.data.message[0].ITEMDESCRIPTION,
                                Order_Type: Oredrvalue,
                            }
                        });

                    } else {
                        Swal.fire({
                            icon: "info",
                            text: 'Serial Number Not Match!.'
                        });
                    }
                })
                .catch(error => {
                    if (error.response) {
                        Swal.fire({
                            icon: "warning",
                            text: error.response.data.message
                        });
                    } else if (error.request) {
                        console.error('No response received');
                    } else {
                        console.error('Error setting up the request:', error.message);
                    }
                }).finally(() => {
                    setOpen(false);
                });
        }
    }

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const handleOrderTypeChange = (event) => {
        setOredrvalue(event.target.value);
    };

    const handleFAQClose = () => {
        setFAQ(false);
    };

    const HandleDealerChange = (newValue) => {
        if (newValue) {
            setOpen(true);
            const data = { type: 'DealerNameCode', User_Id: newValue }
            axios.post(BASE_URL + '/siso', data)
                .then(response => {
                    if (response.status === 200) {
                        if (response.data.message.length >= 1) {
                            setDealer(response.data.message);
                        } else {
                            Swal.fire({
                                icon: "info",
                                text: 'Invalid Dealer!'
                            });
                            // navigate('/Home');
                        }
                    } else {
                        Swal.fire({
                            icon: "warning",
                            text: 'Unexpected response status. Please try again.'
                        });
                    }
                })
                .catch(error => {
                    if (error.response) {
                        Swal.fire({
                            icon: "warning",
                            text: `Error: ${error.response.data.message}`
                        });
                    } else if (error.request) {
                        console.error('No response received');
                    } else {
                        console.error('Error setting up the request:', error.message);
                    }
                }).finally(() => {
                    setOpen(false);
                });
        }
    }

    const DEALER_LIST = DealerDetail ? DealerDetail.map((type) => ({
        Value: type.DEALER_CODE,
        Label: type.DEALERNAME,
    })) : [];

    return (
        <>
            <div className="m-4">
                <Card className="shadow bg-white rounded">
                    <center><h4 style={{ fontWeight: '1000' }}><i>SPARES IDENTIFICATION SOFTWARE</i></h4></center>
                    <hr /> 
                    {DealerDetail.length > 0 && (
                        <>
                            {DealerDetail.length === 1 ? (
                                <>
                                    <div className='row'>
                                        {/* <div className='col-md-6 mt-2'>
                                            <TextField label="Dealer Code" value={DealerDetail[0].DEALER_CODE} size="small" fullWidth />
                                        </div>
                                        <div className='col-md-6 mt-2'> */}
                                        {/* </div> */}
                                        <TextField label="Dealer Name" value={DealerDetail[0].DEALERNAME} size="small" fullWidth />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <SelectSearch
                                        readOnly={true}
                                        label="Dealer Name"
                                        options={DEALER_LIST}
                                        value={dealer}
                                        size={"small"}
                                        onChange={(newValue) => HandleDealerChange(newValue)}
                                    />
                                </>
                            )}
                            <br />
                            <div className='row'>
                                <div className='col-md-6 mt-2'>
                                    <center><b>Product Details</b></center>
                                    <RadioGroup value={value} onChange={handleChange} row sx={{ justifyContent: 'center', textAlign: 'center' }} >
                                        <FormControlLabel value="Product" control={<Radio />} label="Product" />
                                        <FormControlLabel value="Serial No" control={<Radio />} label="Serial No" />
                                    </RadioGroup>
                                </div>
                                <div className='col-md-6 mt-2'>
                                    <center><b>Order Type</b></center>
                                    <RadioGroup value={Oredrvalue} onChange={handleOrderTypeChange} row sx={{ justifyContent: 'center', textAlign: 'center' }}>
                                        {OrderType && OrderType.map((ot, index) => (
                                            <FormControlLabel
                                                key={ot.order_type}
                                                value={ot.order_type}
                                                // control={<Radio />}
                                                control={<Radio inputRef={index === 0 ? focusRef : null} />}
                                                label={ot.order_type}
                                                disabled={ot.Active == 1 ? false : true}
                                            />
                                        ))}
                                    </RadioGroup>
                                </div>
                            </div>
                        </>
                    )}
                </Card>
                <br />
                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
                    <CircularProgress color="inherit" />
                </Backdrop>
                {value === 'Serial No' && (
                    <Card className="shadow bg-white rounded">
                        <div className='row'>
                            <div className='col-md-8 mt-2'>
                                <TextField label="Serial Number" value={SerialNo} onChange={(e) => setSerialNo(e.target.value)} size="small" fullWidth />
                            </div>
                            <div className='col-md-4 mt-2'>
                                <Button fullWidth variant="contained" endIcon={<RemoveRedEyeRoundedIcon />} onClick={SerialSearch} style={buttonStyle} ><b>View</b></Button>
                            </div>
                        </div>
                    </Card>
                )}
                {value === 'Product' && (
                    <Card className="shadow bg-white rounded">
                        {DealerDetail.length === 1 ? (
                            <>
                                <ProductSelection_INCLUDE
                                    DealerName={DealerDetail.length > 0 ? DealerDetail[0].DEALERNAME : ''}
                                    DealerCode={DealerDetail.length > 0 ? DealerDetail[0].DEALER_CODE : ''}
                                    Order_Type={Oredrvalue}
                                />
                            </>
                        ) : (
                            <>
                                <ProductSelection_INCLUDE
                                    DealerName={dealer.length > 0 ? dealer[0].DEALERNAME : ''}
                                    DealerCode={dealer.length > 0 ? dealer[0].DEALER_CODE : ''}
                                    Order_Type={Oredrvalue}
                                />
                            </>
                        )}
                    </Card>
                )}
                <br />
                <Card className="shadow bg-white rounded">
                    <Button onClick={() => setFAQ(true)} endIcon={<ContactSupportIcon />} fullWidth variant="contained" style={buttonStyle} ><b>FAQ..</b></Button>
                </Card>
                {FAQ && (
                    <FAQPopup onClose={handleFAQClose} />
                )}
            </div>
        </>
    );
};

const FAQPopup = ({ data, onClose }) => {
    return (
        <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth sx={{ justifyContent: 'center' }}>
            <DialogTitle><center><u><b>FAQ</b></u></center></DialogTitle>
            <DialogContent>
			{/*<div className="text-muted h2"><center>No Data Found!</center></div> */}
			<br />
			<center>
				<img src={NoDataFound} alt={""} style={{ width: '100px' }} />
				<h5 style={{ fontWeight: '700' }}><i>No data available</i></h5>
			</center>
			<br />
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center' }}>
                <Stack sx={{ width: '100%', maxWidth: '400px' }}>
                    <CustomButton
                        label="Cancel"
                        onClick={onClose}
                        variant="outlined"
                        color="error"
                        fullWidth
                    />
                </Stack>
            </DialogActions>
        </Dialog>
    );
}